import { IOption } from 'libs/shared/src/lib/in-house-input-select/in-house-input-select.model';

export const transformStrWithSpaces = (str: string) => {
  return str.replace(/([A-Z])/g, ' $1');
};

export const transformStrWithNoSpaces = (str: string) => {
  return str.replace(/\s+([A-Z])/g, '$1');
};

export const returnSelectedOptionFromOptions = (
  options: IOption[] | undefined,
  value: string | undefined | null | boolean | string[],
  activeOptions?: boolean
): IOption | IOption[] => {
  if (value === undefined) return [];

  if (!options) return {} as IOption;

  if (Array.isArray(value)) {
    const selectedOptions: IOption[] = value.map((v) => {
      return {
        text: options.find((opt) => opt.value === v)?.text ?? '',
        value: v,
      };
    });

    return selectedOptions;
  }

  if (activeOptions) {
    if (value) return { value: 'active', text: 'Active' };

    return { value: 'inactive', text: 'Inactive' };
  }

  return {
    value: (value as string) ?? '',
    text: options.find((opt) => opt.value === value)?.text ?? '',
  };
};

export const getKeyByValue = <T extends object>(
  obj: T,
  value: string
): keyof T | undefined => {
  return Object.keys(obj).find((key) => obj[key as keyof T] === value) as
    | keyof T
    | undefined;
};
